import * as t from 'io-ts';
import { CustomerDynamicType } from './customer';

export const CustomerContactDetailsDynamicType = t.interface({
    // Note that 'name' is actually the name of the customer, not the contact.
    name: t.union([t.string, t.null]),
    contactName: t.string,
    telephoneNumber: t.union([t.string, t.null]),
    mobileNumber: t.union([t.string, t.null]),
    email: t.union([t.string, t.null]),
    accountId: t.number,
    customers: t.array(CustomerDynamicType),
    language: t.union([t.string, t.null]),
    bestAcsContactTelephoneNumber: t.union([t.string, t.null]),
    mainSiteLink: t.union([t.string, t.null]),
});

export type CustomerContactDetails = t.TypeOf<typeof CustomerContactDetailsDynamicType>;
